@if (isCreatingNew) {
  <ep-distribution-create-new [isFallback]="isFallback" (saved)="newDistributionSaved($event)"
  (cancelled)="newDistributionCancelled()"></ep-distribution-create-new>
} @else {
  <div class="pageheader">
    <div class="page-title">
      <h1>Distribution Details</h1>
      <div class="btn-group">
        <button class="btn btn-link" [disabled]="!selectedDistribution() || isEditing"
          (click)="refresh($safeNavigationMigration(selectedDistribution()?.DistributionsId))">
          Refresh <ep-svg-icon icon="repeat">
        </ep-svg-icon>
      </button>
      <app-change-log-link *bizPermissionRequired="'Distribution_Action_ShowLog'" [disabled]="!selectedDistribution()"
        [title]="'Logs for selected distribution'">
        <app-change-log-link-entity type="Distribution" [id]="$safeNavigationMigration(selectedDistribution()?.DistributionsId)"></app-change-log-link-entity>
      </app-change-log-link>
    </div>
    @if (!isEditing) {
      <div class="btn-group">
        <button class="btn btn-link" id="btnNew"
          *bizPermissionRequired="'Distribution_Action_DistributionCreate'" (click)="createNew()">
          Create new
          <ep-svg-icon icon="plus"></ep-svg-icon>
        </button>
      </div>
    }
  </div>
  <div class="pageheader-warnings">
    <restricted-search-callout
      [visible]="$safeNavigationMigration(this.selectedDistribution()?.ContextPropertyFilters?.length) > 0"
      header="Filters are enabled",
      [type]="RestrictedSearchCalloutType.Warning"
      text="This distribution has enabled context property filters">
    </restricted-search-callout>
  </div>
</div>
<div class="container container-fixed">
  <div class="form-group btn-info-container " data-toggle="buttons"
    [hidden]="!distributions || distributions?.length < 2">
    @for (distribution of distributions; track distribution) {
      <label class="btn btn-info-button"
        [class.active]="selectedDistribution()?.DistributionsId === distribution?.DistributionsId"
        >
        <input [disabled]="isEditing" type="radio" [value]="distribution" [ngModel]="selectedDistribution()"
          (ngModelChange)="selectedDistributionChanged(distribution)">
          <span class="id">{{distribution?.DistributionsId}}<button class="btn btn-sm pull-right"
            (click)="removeDistributionClick(distribution)" [disabled]="isEditing"
          title="Close distribution">X</button></span>
          <span class="hr"></span>
          <span style="font-style: italic"
          class="DistributionObject">{{distribution?.DocumentConfigIn?.DistributionObject?.Name}}</span>
          @if (isFallbackDistribution(distribution) && fallbackDistributionDirection(distribution) === 'In') {
            <span
            class="PartnerIn">Ingoing Fallback</span>
          }
          @if (isFallbackDistribution(distribution) && fallbackDistributionDirection(distribution) === 'Out') {
            <span
            class="PartnerIn">Outgoing Fallback</span>
          }
          <span class="PartnerIn">{{distribution?.PartnerIn?.PartnerName}}</span>
          <span class="PartnerOut">{{distribution?.PartnerOut?.PartnerName}}</span>
        </label>
      }
    </div>
    <div class="form-group btn-toolbar">
      @if (!isEditing) {
        @if (!isFallbackDistribution(selectedDistribution())) {
          <div class="btn-group">
            <button class="btn btn-primary btn-sm" id="btnEdit"
              *bizPermissionRequired="['Distribution_Action_DistributionEdit']; type:'And'; trigger: selectedDistribution()"
              [disabled]="!selectedDistribution()" (click)="edit()">
              Edit
            </button>
          </div>
        } @else if (isFallbackDistribution(selectedDistribution())) {
          <div class="btn-group">
            <button class="btn btn-primary btn-sm" id="btnEdit"
              *bizPermissionRequired="['Distribution_Action_FallbackDistributionEdit']; type:'And'; trigger: selectedDistribution()"
              [disabled]="!selectedDistribution()" (click)="edit()">
              Edit
            </button>
          </div>
        }
      }
      @if (isEditing) {
        <div class="btn-group">
          <button class="btn btn-primary btn-sm" id="btnSave" [disabled]="!selectedDistribution()" (click)="save()">
            Save
          </button>
        </div>
        <div class="btn-group">
          <button class="btn btn-link btn-sm" id="btnCancel" [disabled]="!selectedDistribution()" (click)="cancel()">
            Cancel
          </button>
        </div>
      }
      @if (!isEditing) {
        @if (!isFallbackDistribution(selectedDistribution())) {
          <div class="btn-group">
            <button class="btn btn-primary btn-sm" id="btnExport"
              *bizPermissionRequired="['Distribution_Action_DistributionExport']; type:'And'; trigger: selectedDistribution()"
              [disabled]="!selectedDistribution() || !selectedDistribution().DistributionsId" (click)="export()">
              Export
            </button>
          </div>
        } @else if (isFallbackDistribution(selectedDistribution())) {
          <div class="btn-group">
            <button class="btn btn-primary btn-sm" id="btnExport"
              *bizPermissionRequired="['Distribution_Action_FallbackDistributionExport']; type:'And'; trigger: selectedDistribution()"
              [disabled]="!selectedDistribution() || !selectedDistribution().DistributionsId" (click)="export()">
              Export
            </button>
          </div>
        }
      }
      @if (!isFallbackDistribution(selectedDistribution())) {
        <div class="btn-group">
          <button class="btn btn-primary btn-sm" id="btnDelete"
            *bizPermissionRequired="['Distribution_Action_DistributionDelete']; type:'And'; trigger: selectedDistribution()"
            [disabled]="!selectedDistribution() || isEditing" (click)="delete()">
            Delete
          </button>
        </div>
      } @else if (isFallbackDistribution(selectedDistribution())) {
        <div class="btn-group">
          <button class="btn btn-primary btn-sm" id="btnDelete"
            *bizPermissionRequired="['Distribution_Action_FallbackDistributionDelete']; type:'And'; trigger: selectedDistribution()"
            [disabled]="!selectedDistribution() || isEditing" (click)="delete()">
            Delete
          </button>
        </div>
      }
      @if (!isFallbackDistribution(selectedDistribution())) {
        <div class="btn-group">
          <button class="btn btn-primary btn-sm" id="btnUpload"
            *bizPermissionRequired="['Distribution_Action_UploadTestFile']; type:'And'; trigger: selectedDistribution()"
            [disabled]="!selectedDistribution() || isEditing" (click)="uploadTestFile()">
            Upload test file
          </button>
        </div>
      } @else if (isFallbackDistribution(selectedDistribution())) {
        <div class="btn-group">
          <button class="btn btn-primary btn-sm" id="btnUpload"
            *bizPermissionRequired="['Distribution_Action_FallbackUploadTestFile']; type:'And'; trigger: selectedDistribution()"
            [disabled]="!selectedDistribution() || isEditing" (click)="uploadTestFile()">
            Upload test file
          </button>
        </div>
      }
      @if (!isFallbackDistribution(selectedDistribution())) {
        <div class="btn-group">
          <button class="btn btn-primary btn-sm" id="btnUpload"
            *bizPermissionRequired="'Distribution_Action_ViewRawDistribution'"
            [disabled]="!selectedDistribution() || isEditing" (click)="viewRawDistribution()">
            Show raw
            distribution details
          </button>
        </div>
      } @else if (isFallbackDistribution(selectedDistribution())) {
        <div class="btn-group">
          <button class="btn btn-primary btn-sm" id="btnUpload"
            *bizPermissionRequired="'Distribution_Action_ViewRawFallbackDistribution'"
            [disabled]="!selectedDistribution() || isEditing" (click)="viewRawDistribution()">
            Show raw
            distribution details
          </button>
        </div>
      }
      @if (currentHasAlertConfiguration && selectedDistribution()?.AlertConfigurationPresentation.Id !== 0) {
        <div class="btn-group">
          <button type="button" class="btn btn-primary btn-sm" id="btnShowAlertHistory"
            *bizPermissionRequired="'Alert_Action_ShowHistory'"
            (click)="showAlertHistory(selectedDistribution().AlertConfigurationPresentation.Id)">
            Show alert history
          </button>
        </div>
      }
      @if (currentHasAlertConfiguration && selectedDistribution()?.AlertConfigurationPresentation.Id !== 0) {
        <div class="btn-group">
          <button type="button" class="btn btn-primary btn-sm" id="btnCancelAlert"
            *bizPermissionRequired="'Alert_Action_CancelAlert'"
            (click)="cancelAlert()">
            Cancel alert
          </button>
        </div>
      }
    </div>
    <!-- end toolbar-->
    @if (selectedDistribution()) {
      <fieldset [disabled]="!isEditing">
        <section>
          <h2>
            {{selectedDistributionObject?.Name}} @if (isFallbackDistribution(selectedDistribution())) {
            <span
            class="label label-info">Fallback Distribution</span>
          }
        </h2>
        <div class="row">
          <div class="col-sm-4">
            <div class="form-group">
              <div class="control control-checkbox">
                <label>
                  Enabled<input [disabled]="!isEditing" type="checkbox"
                  [ngModel]="$safeNavigationMigration(selectedDistribution()?.IsActive)"
                  (ngModelChange)="selectedDistribution().IsActive = $event" /><i></i>
                </label>
              </div>
            </div>
          </div>
          <div class="col-sm-8">
            <div class="form-group">
              <label>Description</label>
              @if (!isEditing) {
                <p>{{selectedDistribution()?.Description}}</p>
              }
              @if (isEditing) {
                <textarea class="form-control"
                  [ngModel]="$safeNavigationMigration(selectedDistribution()?.Description)"
                (ngModelChange)="selectedDistribution().Description = $event" rows="2"></textarea>
              }
            </div>
          </div>
        </div>
      </section>
      <div class="row">
        @if ((distributionConfigurationKeys | async)?.length > 0) {
          <div class="col-sm-6">
            <h4>Configuration Keys for distribution</h4>
            <div>
              <ep-datafield-group-container #configurationKeysDistributionContainer [showGroupHeaders]="false" [formValidationGroup]="validationFormGroup"
                [datafieldGroups]="distributionConfigurationKeys | async" [isAlwaysEditable]="true"
              [numberOfColumns]="1"></ep-datafield-group-container>
            </div>
          </div>
        }
        @if ((distributionObjectConfigurationKeys | async)?.length > 0) {
          <div class="col-sm-6">
            <h4>Configuration Keys for Document Type</h4>
            <div>
              <ep-datafield-group-container #configurationKeysDistributionContainer [formValidationGroup]="validationFormGroup"
                [showGroupHeaders]="false" [datafieldGroups]="distributionObjectConfigurationKeys | async"
              [isAlwaysEditable]="true" [numberOfColumns]="1"></ep-datafield-group-container>
            </div>
          </div>
        }
      </div>
      <div class="row">
        <!-- Caching -->
        @if (selectedDistributionObject?.AllowCaching) {
          <div class="col-sm-3">
            <h2>Caching</h2>
            <div class="panel panel-default panel-body">
              <div class="controls-inline">
                <div class="control control-checkbox">
                  <label>
                    Use Caching <input type="checkbox" [disabled]="!isEditing"
                    [ngModel]="$safeNavigationMigration(selectedDistribution()?.UseCaching)"
                    (ngModelChange)="selectedDistribution().UseCaching = $event" /><i></i>
                  </label>
                </div>
              </div>
            </div>
          </div>
        }
        <!-- Light Tracking -->
        @if (selectedDistributionObject?.AllowLightTracking) {
          <div class="col-sm-9">
            <h2>Light Tracking</h2>
            <div class="panel panel-default panel-body">
              <div class="controls-inline">
                <div class="control control-checkbox">
                  <label>
                    Message In Backup <input type="checkbox" [disabled]="!isEditing"
                    [ngModel]="$safeNavigationMigration(selectedDistribution()?.UseMessageInBackup)"
                    (ngModelChange)="selectedDistribution().UseMessageInBackup = $event" /><i></i>
                  </label>
                </div>
                <div class="control control-checkbox">
                  <label>
                    CDM Backup <input type="checkbox" [disabled]="!isEditing"
                    [ngModel]="$safeNavigationMigration(selectedDistribution()?.UseCdmBackup)"
                    (ngModelChange)="selectedDistribution().UseCdmBackup = $event" /><i></i>
                  </label>
                </div>
                <div class="control control-checkbox">
                  <label>
                    Interchange Out Backup <input type="checkbox" [disabled]="!isEditing"
                    [ngModel]="$safeNavigationMigration(selectedDistribution()?.UseInterchangeOutBackup)"
                    (ngModelChange)="selectedDistribution().UseInterchangeOutBackup = $event" /><i></i>
                  </label>
                </div>
              </div>
            </div>
          </div>
        }
      </div>
      <!-- Partner -->
      <div class="row">
        <div class="col-sm-6">
          <h2>From Partner</h2>
          <div class="panel panel-default">
            <div class="panel-body">
              @if (isShowPartnerIn) {
                <div>
                  <div class="form-group">
                    <label>Partner</label>
                    <ep-partner-selector id="fromPartnerID" #partnerSelectorFrom
                      [isReadOnly]="!isEditing" [selectedPartner]="$safeNavigationMigration(selectedDistribution()?.PartnerIn)"
                      (selectedPartnerChange)="selectedDistribution().PartnerIn = $event; invokeFindPartnerConfigurationKeys(directionEnum.In)">
                    </ep-partner-selector>
                  </div>
                  <!-- Partner Configuration Keys -->
                  @if ((partnerFromObjectConfigurationKeys | async)?.length > 0) {
                    <div
                      class="panel panel-default panel-collapsable"
                      [class.panel-collapsed]="showPartnerInConfigurationKeys">
                      <div class="panel-heading"
                        (click)="showPartnerInConfigurationKeys = !showPartnerInConfigurationKeys">
                        <h3 class="panel-title">Configuration Keys for Partner</h3>
                      </div>
                      <div class="panel-body panel-animate" [hidden]="showPartnerInConfigurationKeys">
                        <ep-datafield-group-container #configurationKeysDistributionContainer [formValidationGroup]="validationFormGroup"
                          [showGroupHeaders]="false"
                          [datafieldGroups]="partnerFromObjectConfigurationKeys | async"
                          [isAlwaysEditable]="true" [numberOfColumns]="1">
                        </ep-datafield-group-container>
                      </div>
                    </div>
                  }
                </div>
              }
            </div>
          </div>
        </div>
        <div class="col-sm-6">
          <h2>To Partner</h2>
          <div class="panel panel-default">
            <div class="panel-body">
              @if (isShowPartnerOut) {
                <div>
                  <div class="form-group">
                    <label>Partner</label>
                    <ep-partner-selector id="toPartnerID" #partnerSelectorTo [isReadOnly]="!isEditing"
                      [selectedPartner]="$safeNavigationMigration(selectedDistribution()?.PartnerOut)"
                      (selectedPartnerChange)="selectedDistribution().PartnerOut = $event; invokeFindPartnerConfigurationKeys(directionEnum.Out)">
                    </ep-partner-selector>
                  </div>
                  <!-- Partner Configuration Keys -->
                  @if ((partnerToObjectConfigurationKeys | async)?.length > 0) {
                    <div
                      class="panel panel-default panel-collapsable"
                      [class.panel-collapsed]="showPartnerInConfigurationKeys">
                      <div class="panel-heading"
                        (click)="showPartnerInConfigurationKeys = !showPartnerInConfigurationKeys">
                        <h3 class="panel-title">Configuration Keys for Partner</h3>
                      </div>
                      <div class="panel-body panel-animate" [hidden]="showPartnerInConfigurationKeys">
                        <ep-datafield-group-container #configurationKeysDistributionContainer [formValidationGroup]="validationFormGroup"
                          [showGroupHeaders]="false"
                          [datafieldGroups]="partnerToObjectConfigurationKeys | async"
                          [isAlwaysEditable]="true" [numberOfColumns]="1">
                        </ep-datafield-group-container>
                      </div>
                    </div>
                  }
                </div>
              }
              <div class="form-group">
                <br>
                  <ep-transport-configuration-selector
                    id="toLocationId"
                    [disabled]="!isEditing"
                    [selectFirstItemIfOnlyOne]="true"
                    [ignoreEmptyPartner]="!isShowPartnerOut"
                    [partnerId]="$safeNavigationMigration(selectedDistribution()?.PartnerOut?.PartnersId)"
                    [transportConfiguration]="$safeNavigationMigration(selectedDistribution()?.TransportConfigurationOut)"
                    (transportConfigurationChange)="setTransportConfigurationOut($event)">
                  </ep-transport-configuration-selector>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- Acknowledgement -->
        <div class="row">
          <div class="col-sm-6">
            <h2>Acknowledgement Out</h2>
            <div class="panel panel-default">
              <div class="panel-body" style="min-height: 90px">
                <div class="control">
                  <label>Send acknowledgement</label>
                  <select class="form-control" [(ngModel)]="selectedDistribution().SendAcknowledgement">
                    @for (ao of acknowledgementOptions; track ao) {
                      <option [ngValue]="ao.value">{{ao.name}}</option>
                    }
                  </select>
                </div>
              </div>
            </div>
          </div>
          <div class="col-sm-6">
            <h2>Acknowledgement In</h2>
            <div class="panel panel-default">
              <div class="panel-body" style="min-height: 90px">
                <div class="row">
                  <div class="control col-sm-4">
                    <label>Expect acknowledgement</label>
                    <div class="control-checkbox ">
                      <label>
                        <input [disabled]="!isEditing" type="checkbox"
                          [ngModel]="$safeNavigationMigration(selectedDistribution()?.ExpectAcknowledgement)"
                          (ngModelChange)="selectedDistribution().ExpectAcknowledgement = $event; resetDefaultValue();" /><i></i>
                        </label>
                      </div>
                    </div>
                    <div class="control col-sm-4">
                      <label>Timeout (in minutes)</label>
                      <input [disabled]="!isEditing || !selectedDistribution()?.ExpectAcknowledgement"
                        class="form-control" type="number"
                        [ngModel]="$safeNavigationMigration(selectedDistribution()?.AcknowledgementTimeout)"
                        (ngModelChange)="selectedDistribution().AcknowledgementTimeout = $event" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- DocumentConfig -->
            <div class="flex-row">
              <div class="item">
                <h2>From Format</h2>
                <div class="row">
                  <div class="col-sm-10">
                    <div class="form-group">
                      <ep-document-config-selector-simple id="fromFormatId" #docConfigInSimple direction="In"
                        [showAllOption]="true" showAllOptionText="Please choose..."
                        [selectFirstItemIfOnlyOne]="true" [distributionObject]="selectedDistributionObject"
                        [documentConfig]="$safeNavigationMigration(selectedDistribution()?.DocumentConfigIn)"
                        (documentConfigChange)="selectedDistribution().DocumentConfigIn = $event; invokeFindFormatTypeConfigurationKeys(directionEnum.In); invokeFindDocumentConfigConfigurationKeys(directionEnum.In)">
                      </ep-document-config-selector-simple>
                    </div>
                  </div>
                </div>
                <!-- FormatType Configuration Keys -->
                @if ((formatTypeFromObjectConfigurationKeys | async)?.length > 0) {
                  <div>
                    <h4>Configuration Keys for Format Type</h4>
                    <div>
                      <ep-datafield-group-container #configurationKeysDistributionContainer [formValidationGroup]="validationFormGroup"
                        [showGroupHeaders]="false"
                        [datafieldGroups]="formatTypeFromObjectConfigurationKeys | async"
                      [isAlwaysEditable]="true" [numberOfColumns]="1"></ep-datafield-group-container>
                    </div>
                  </div>
                }
                <!-- DocumentConfig Configuration Keys -->
                @if ((documentConfigFromObjectConfigurationKeys | async)?.length > 0) {
                  <div>
                    <h4>Configuration Keys for Document Config</h4>
                    <div [hidden]="showDocumentConfigInConfigurationKeys">
                      <ep-datafield-group-container #configurationKeysDistributionContainer [formValidationGroup]="validationFormGroup"
                        [showGroupHeaders]="false"
                        [datafieldGroups]="documentConfigFromObjectConfigurationKeys | async"
                      [isAlwaysEditable]="true" [numberOfColumns]="1"></ep-datafield-group-container>
                    </div>
                  </div>
                }
              </div>
              <div class="item">
                <h2>To Format</h2>
                <div class="row">
                  <div class="col-sm-10">
                    <div class="form-group">
                      <ep-document-config-selector-simple id="toFormatId" #docConfigOutSimple direction="Out"
                        [showAllOption]="true" showAllOptionText="Please choose..."
                        [selectFirstItemIfOnlyOne]="true" [distributionObject]="selectedDistributionObject"
                        [documentConfig]="$safeNavigationMigration(selectedDistribution()?.DocumentConfigOut)"
                        (documentConfigChange)="selectedDistribution().DocumentConfigOut = $event; invokeFindFormatTypeConfigurationKeys(directionEnum.Out); invokeFindDocumentConfigConfigurationKeys(directionEnum.Out)">
                      </ep-document-config-selector-simple>
                    </div>
                  </div>
                </div>
                <!-- FormatType Configuration Keys -->
                @if ((formatTypeToObjectConfigurationKeys | async)?.length > 0) {
                  <div>
                    <h4>Configuration Keys for Format Type</h4>
                    <div [hidden]="showFormatTypeOutConfigurationKeys">
                      <ep-datafield-group-container #configurationKeysDistributionContainer [formValidationGroup]="validationFormGroup"
                        [showGroupHeaders]="false"
                        [datafieldGroups]="formatTypeToObjectConfigurationKeys | async"
                      [isAlwaysEditable]="true" [numberOfColumns]="1"></ep-datafield-group-container>
                    </div>
                  </div>
                }
                <!-- DocumentConfig Configuration Keys -->
                @if ((documentConfigToObjectConfigurationKeys | async)?.length > 0) {
                  <div
                    class="panel panel-default panel-collapsable"
                    [class.panel-collapsed]="showDocumentConfigOutConfigurationKeys">
                    <div class="panel-body">
                      <h4 style="margin-top:0">Configuration Keys for Document Config</h4>
                      <div [hidden]="showDocumentConfigOutConfigurationKeys">
                        <ep-datafield-group-container #configurationKeysDistributionContainer [formValidationGroup]="validationFormGroup"
                          [showGroupHeaders]="false"
                          [datafieldGroups]="documentConfigToObjectConfigurationKeys | async"
                        [isAlwaysEditable]="true" [numberOfColumns]="1"></ep-datafield-group-container>
                      </div>
                    </div>
                  </div>
                }
              </div>
            </div>
            <!-- Itinerary -->
            <div class="row mb-2">
              <div class="col-sm-6">
                <h2>From Itinerary</h2>
                <app-distribution-itinerary #distributionItineraryIn [distribution]="selectedDistribution()"
                [documentConfig]="selectedDistribution().DocumentConfigIn"></app-distribution-itinerary>
              </div>
              <div class="col-sm-6">
                <h2>To Itinerary</h2>
                <app-distribution-itinerary #distributionItineraryOut [distribution]="selectedDistribution()"
                [documentConfig]="selectedDistribution().DocumentConfigOut"></app-distribution-itinerary>
              </div>
            </div>
            <!-- Alert -->
            @if(this.showAlert)
              {
              <div class="row">
                @if (currentHasAlertConfiguration) {
                  <div class="col-sm-12 mb-2 panel panel-default">
                    <h2>Alert configuration</h2>
                    <app-alert-configuration-edit #alertConfiguration
                      [(alertConfiguration)]="selectedDistribution().AlertConfigurationPresentation" [isReadOnly]="!isEditing"
                    [senderPartner]="$safeNavigationMigration(selectedDistribution()?.PartnerIn?.PartnersId)" [receivingPartner]="$safeNavigationMigration(selectedDistribution()?.PartnerOut?.PartnersId)"></app-alert-configuration-edit>
                  </div>
                }
                <div class="col-sm-12">
                  <div class="btn-toolbar">
                    <button type="button" class="btn btn-primary" [disabled]="currentHasAlertConfiguration"
                    (click)="addAlert()">Add alert</button>
                    <button type="button" class="btn btn-primary" [disabled]="!currentHasAlertConfiguration"
                    (click)="removeAlert()">Remove alert</button>
                  </div>
                </div>
              </div>
            }
            <!-- Advanced -->
            <section>
              <h2 (click)="showAdvanced = !showAdvanced" style="cursor: pointer;">
                Advanced
                <i [ngClass]="showAdvanced ? 'dx-icon-chevronup' : 'dx-icon-chevrondown'" aria-hidden="true"></i>
              </h2>
              <div [hidden]="!showAdvanced">
                <!-- Context Property Filters -->
                <form #tForm="ngForm">
                  <div class="row">
                    <div class="col-sm-12">
                      <app-context-property-filters
                        [filters]="propertyFilters()"
                        [readonly]="!isEditing"
                        (filtersChange)="onPropertyFiltersChange($event)">
                      </app-context-property-filters>
                    </div>
                  </div>
                </form>
                <div class="row">
                  <div class="col-sm-3 form-group">
                    <h4>Filenaming</h4>
                    <select id="selectFilenaming" class="form-control"
                      [ngModel]="$safeNavigationMigration(selectedDistribution()?.FilenamingTypeId)"
                      (ngModelChange)="selectedDistribution().FilenamingTypeId = $event">
                      <option [ngValue]="null">None</option>
                      @for (filenamingType of filenamingTypes | async; track filenamingType) {
                        <option
                          [ngValue]="filenamingType.FilenamingTypesId">
                          {{filenamingType.FilenamingTypeName}}
                        </option>
                      }
                    </select>
                  </div>
                </div>
                <!-- DUPLICATE CHECK -->
                <div class="row">
                  <div class="col-sm-6 form-group">
                    <h4>Choose duplicate check types</h4>
                    @for (duplicateCheckType of duplicateCheckTypes; track duplicateCheckType; let i = $index) {
                      <div
                        class="panel panel-default">
                        <div class="panel-body">
                          <div class="control control-checkbox form-group">
                            <label ngbTooltip="{{duplicateCheckType.Description}}">
                              <input type="checkbox" [disabled]="!isEditing"
                                [(ngModel)]="duplicateCheckType.isSelected" />
                                <i></i>
                                {{duplicateCheckType.Name}}
                              </label>
                            </div>
                            @if (duplicateCheckType.isSelected && duplicateCheckType.duplicateCheckConfig?.length > 0) {
                              <ep-datafield-group-container #duplicateCheckAdvancedObjectContainer [formValidationGroup]="validationFormGroup"
                                [datafieldGroups]="duplicateCheckType.duplicateCheckConfig"
                                [isAlwaysEditable]="true" [numberOfColumns]="2"
                                [referenceId]="duplicateCheckType.Id">
                              </ep-datafield-group-container>
                            }
                          </div>
                        </div>
                      }
                    </div>
                  </div>
                  <div class="row">
                    <div class="form-group">
                      <!-- Advanced Configuration Keys -->
                      @if ((distributionAdvancedConfigurationKeys | async)?.length > 0) {
                        <div>
                          <h4>Configuration Keys for advanced options</h4>
                          <div>
                            <ep-datafield-group-container #configurationKeysDistributionContainer [formValidationGroup]="validationFormGroup"
                              [showGroupHeaders]="false"
                              [datafieldGroups]="distributionAdvancedConfigurationKeys | async"
                            [isAlwaysEditable]="true" [numberOfColumns]="2"></ep-datafield-group-container>
                          </div>
                        </div>
                      }
                    </div>
                  </div>
                  <div class="row">
                    <div class="form-group">
                      <!-- Batching Configuration -->
                      <!--<div *ngIf="selectedDistribution()?.Id > 0">-->
                      <h4>Batching Configuration</h4>
                      <div class="col-sm-6">
                        <ep-batching-selector #batchingSelector [documentConfig]="selectedDistribution().DocumentConfigOut" [isEditing]="isEditing" [distribution]="selectedDistribution()"></ep-batching-selector>
                      </div>
                    <!--</div>-->
                  </div>
                </div>
              </div>
            </section>
            <!-- Save/Cancel -->
            @if (isEditing) {
              <hr />
            }
            <section class="mb50">
              @if (isEditing) {
                <div class="btn-group">
                  <button class="btn btn-primary btn-sm" id="btnSave" [disabled]="!selectedDistribution()"
                    (click)="save()">
                    Save
                  </button>
                </div>
              }
              @if (isEditing) {
                <div class="btn-group">
                  <button class="btn btn-link btn-sm" id="btnCancel" [disabled]="!selectedDistribution()"
                    (click)="cancel()">
                    Cancel
                  </button>
                </div>
              }
            </section>
          </fieldset>
        }
      </div>
    }

